<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cent">
      <div class="cent_1">
        <div class="cent_top">
          <div class="cent_top_content">
            <img src="../../assets/img/dingdan/pay_icon_order.png" alt />
            <p>订单号：{{lists.order_sn}}</p>
          </div>
        </div>
        <div class="cent_bottom">
          <div class="cent_bottom_1">
            <ul>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step01_sel.png" alt />
                <p>沟通需求</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step02_sel.png" alt />
                <p>下单预付</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step03_nor.png" alt />
                <p>为您服务</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step04_nor.png" alt />
                <p>验收服务</p>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="cent_top111">
          <el-button type="primary" class="button" @click="jump()">支付成功</el-button>
        </div>-->
      </div>
    </div>
    <div class="content">
      <div class="content_1">
        <div class="content_top">
          <div class="content_top_p">
            <p style="font-weight:600;">需求标题</p>
            <p class="span1">{{lists.service_name}}</p>
          </div>
          <div class="content_top_p">
            <p style="font-weight:600;">补充需求</p>
            <p class="span1">{{this.remark_member}}</p>
          </div>
          <div class="content_top_p">
            <p style="font-weight:600;">支付金额</p>
            <p class="p1">
              ￥
              <span style="font-size: 20px;">{{lists.goods_price}}</span>
            </p>
          </div>
        </div>
        <div class="content_botton">
          <div class="content_top_p">
            <p style="font-weight:600;" class="content_botton_p">支付方式</p>
            <ul>
              <!-- <li :class="{active:0==numm}" @click="numm=0">
                <img src="../../assets/img/zhifu/pay_icon_zfb.png" alt class="botton_img" />
                <p>支付宝</p>
                <img src="../../assets/img/zhifu/pay_icon_mode_sel.png" alt class="posi_img" />
              </li> -->
              <li :class="{active:1==numm}" @click="numm=1">
                <img src="../../assets/img/zhifu/pay_icon_wx.png" alt class="botton_img" />
                <p>微信</p>
                <img src="../../assets/img/zhifu/pay_icon_mode_sel.png" alt class="posi_img" />
              </li>
              <!-- <li :class="{active:2==numm}" @click="numm=2" style="width: 207px;">
                <img src="../../assets/img/zhifu/pay_icon_yl.png" alt class="botton_img1" />
                <p>企业或个人银行转账支付</p>
                <img src="../../assets/img/zhifu/pay_icon_mode_sel.png" alt class="posi_img" />
              </li> -->
            </ul>
          </div>
          <div class="content_top_p" v-show="numm==0">
            <p style="font-weight:600;" class="content_botton_p"></p>
            <div class="content_botton_div">
              <div class="content_botton_img"></div>
              <p>支付宝扫描二维码完成支付</p>
            </div>
          </div>
          <div class="content_top_p" v-show="numm==1">
            <p style="font-weight:600;" class="content_botton_p"></p>
            <div class="content_botton_div">
              <div class="content_botton_img">
                <img :src="lists.code_url" alt />
              </div>
              <p>微信扫描二维码完成支付</p>
            </div>
          </div>
          <div class="content_top_p" v-show="numm==2">
            <p style="font-weight:600;" class="content_botton_p"></p>
            <div class="content_botton_div">
              <!-- <div class="content_botton_img"></div> -->
              <p style="text-align:center;">建设中...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { payOrder, Index, getOrderInfo } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      numm: 1,
      lists: [],
      orderinfo1: []
    };
  },
  methods: {
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    table(index) {
      this.numm = index;
    },
    jump() {
      this.$router.push({
        name: "fuwuzhong",
        query: {
          order_id: this.lists.id
        }
      });
    },

    getorderInfo(order, price, goods, provide) {
      this.token = localStorage.getItem("token");
      window.setInterval(() => {
        setTimeout(
          getOrderInfo({
            token: this.token,
            order_sn: order, //订单号
            goods_price: price, //价钱
            order_id: goods //订单id，
          }).then(res => {
            this.orderinfo = res.data.data;
            if (this.orderinfo.order_status == 2) {
              this.$router.push({
                name: "yuwuzhong",
                query: {
                  order_id: this.orderinfo.id
                }
              });
            }
          }),
          0
        );
      }, 3000);
    },
    getorderInfo1(order, price, goods, provide) {
      this.token = localStorage.getItem("token");
      getOrderInfo({
        token: this.token,
        order_sn: order, //订单号
        goods_price: price, //价钱
        order_id: goods //订单id，
      }).then(res => {
        this.orderinfo1 = res.data.data;
      });
    },
    getindex(order, price, goods, provide, orderinfo1) {
      this.token = localStorage.getItem("token");
      console.log(this.orderinfo1.goods_num);
      var remark_member = this.$route.query.remark_member;
      Index({
        token: this.token,
        goods_price: price, //价钱
        order_id: goods, //订单id，
        remark_member: remark_member,
        goods_num: this.orderinfo1.goods_num
      }).then(res => {
        this.lists = res.data.data;
      });
    }
  },
  created() {
    var order = this.$route.query.order_id;
    var price = this.$route.query.order_price;
    var goods = this.$route.query.goods_id;
    var provide = this.$route.query.provider_id;
    this.remark_member = this.$route.query.remark_member;
    this.getindex(order, price, goods, provide);
    this.getorderInfo(order, price, goods, provide);
    this.getorderInfo1(order, price, goods, provide);
    this.$emit("header", true); //是否显示头部
  }
};
</script>

<style scoped>
.button {
  width: 130px;
  height: 50px;
  margin: 500px 500px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.cent {
  width: 100%;
  background: #007bff;
}

.cent_1 {
  width: 1200px;
  height: 200px;
  margin: 0 auto;
}

.cent_top {
  width: 100%;
  height: 100px;
  overflow: hidden;
}

.cent_top_content {
  width: 300px;
  height: 62px;
  margin: 20px auto;
}

.cent_top_content img {
  float: left;
  padding: 8px 0;
}

.cent_top_content p {
  line-height: 60px;
  color: #ffffff;
}

.cent_bottom {
  width: 100%;
  height: 100px;
  background: #f4f5f9;
  overflow: hidden;
}

.cent_bottom_1 {
  width: 500px;
  height: 66px;
  margin: 18px auto;
}

.cent_bottom_1 ul li {
  float: left;
  padding: 0 15px;
}

.cent_bottom_1 ul li p {
  font-size: 12px;
  font-weight: 400;
}

.cent_bottom_1 ul li i {
  line-height: 66px;
  font-weight: 600;
}

.content {
  width: 100%;
  height: 686px;
  background: #f4f5f9;
}

.content_1 {
  width: 1200px;
  height: 540px;
  background: #fff;
  margin: 0 auto;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.content_top {
  width: 1000px;
  height: 168px;
  margin: 0 auto;
  border-bottom: 1px solid #e4e4e4ff;
  overflow: hidden;
}

.content_top_p {
  margin: 15px 0 0 0;
  overflow: hidden;
}

.content_top_p p {
  float: left;
  font-size: 14px;
  padding: 0 8px;
}

.span1 {
  width: 910px;
  height: 35px;
}

.p1 {
  font-size: 20px;
  color: #f7681e;
}

.content_botton {
  width: 1000px;
  height: 342px;
  margin: 0 auto;
  overflow: hidden;
}

.content_top_p ul {
  float: left;
  display: flex;
}

.content_top_p ul li {
  width: 130px;
  height: 44px;
  border: 2px solid #e4e4e4;
  margin-left: 10px;
  position: relative;
}

.content_botton_p {
  width: 56px;
  height: 44px;
  line-height: 44px;
}

.botton_img {
  float: left;
  padding: 10px 0 10px 32px;
}

.content_top_p ul li p {
  padding: 0 3px;
  line-height: 42px;
}

.posi_img {
  position: absolute;
  right: 0;
  bottom: 0;
  display: none;
}

.botton_img1 {
  float: left;
  padding: 10px 0 10px 12px;
}

.content_botton_div {
  width: 616px;
  height: 254px;
  background: #f4f5f9;
  border: 1px solid #e4e4e4;
  float: left;
  margin-left: 8px;
}

.content_botton_img {
  width: 200px;
  height: 200px;
  margin: 30px;
  float: left;
}

.content_botton_img img {
  width: 200px;
  height: 200px;
}

.content_botton_div p {
  line-height: 224px;
  color: #666666;
}

.content_top_p ul li.active {
  border: 2px solid #f7681e;
}

.content_top_p ul li.active .posi_img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/Dingdan/Yufu.vue